import { Grid, Typography, Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PropTypes from 'prop-types';
import React from 'react';

import InitScripts from './InitScripts';

VMInitScriptSettings.propTypes = {
  currentVM: PropTypes.object,
  updateCurrentVM: PropTypes.func
};

export function VMInitScriptSettings({ currentVM, updateCurrentVM }) {
  const handleInitScriptChange = (script) => {
    const updatedVM = {
      ...currentVM,
      initScript: script
    };
    updateCurrentVM(updatedVM);
  };

  const handleBootScriptChange = (script) => {
    const updatedVM = {
      ...currentVM,
      bootScript: script
    };
    updateCurrentVM(updatedVM);
  };

  return (
    <Grid item xs={12}>
      <Accordion data-testid="init-script-settings">
        <AccordionSummary sx={{ paddingLeft: 0 }} expandIcon={<ExpandMoreIcon />}>
          <Typography variant="h6">Init Script Settings</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <InitScripts
            setNextButtonDisabled={() => {}}
            rackInitScript={currentVM?.initScript}
            rackBootScript={currentVM?.bootScript}
            updateRackInitScript={handleInitScriptChange}
            updateRackBootScript={handleBootScriptChange}
          />
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
}
